// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2eAK2","rootCenter":"LoadMoreObserver_rootCenter__3UOgA","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3jtqB"};